import config from '../../config';

const CRYSTAL = 'crystal';
const ELECTRIC = 'electric';
const FIRE = 'fire';
const ELEMENT_TYPES = [CRYSTAL, ELECTRIC, FIRE];

function BurstParticle (gameContext) {
  let g = gameContext;
  let particles = g.add.particles('burst-particles');
  let emitters = {};
  _.each(ELEMENT_TYPES, (element) => {
    emitters[element] = particles.createEmitter({
      x: config.CENTER_X,
      y: config.HEIGHT - 300,
      speed: { min: 500, max: 1200 },
      lifespan: 1000,
      gravityY: 1500,
      scale: { start: config.SCALE, end: 0 },
      angle: { min: 200, max: 340 },
      on: false
    });
    emitters[element].setFrame([`particle-${element}1.png`, `particle-${element}2.png`, `particle-${element}3.png`]);
  });
  return emitters;
}

export default BurstParticle;
